export interface ShedManagementState {
    attributesGroup: AttributeGroup[]
    shedsSearchLocations: string[]
    requestsSearchingFilters: number
    filtersSearchLocations: FiltersSearchLocations
    locations: Locations[]
    selectedLocations: SelectedLocations[],
    locationAttributeDiscrepancyErrors: LocationAttributeDiscrepancyErrors[]
    products: Product[]
    selectedProducts: Product[]
    productAttributeDiscrepancyErrors: ProductAttributeDiscrepancyErrors[]
    locationHeightTypes: LocationHeightTypes[]
    createFiltersData: CreateFiltersData | null
    csvValidationErrors: CsvValidationError[]
}

export interface CreateFiltersData {
    fcs: FulfillmentCenter[]
    locationHeightTypes: LocationHeightType[]
    locationTypes: LocationType[]
}

export interface FulfillmentCenter {
    id: number
    name: string
}

export interface LocationHeightType {
    id: number
    name: string
}

export interface LocationType {
    id: number
    name: string
}

export interface AttributeItem {
    id: number;
    name: string;
}

export interface AttributeGroup {
    groupName: string;
    values: AttributeItem[];
}

export interface SetAttributesGroup {
    attributesGroup: ShedManagementState['attributesGroup']
}

export interface SetLocationHeightTypes {
    locationHeightTypes: ShedManagementState['locationHeightTypes']
}

export interface SetCreateFiltersData {
    createFiltersData: ShedManagementState['createFiltersData']
}

export interface SelectedLocations {
    id: number
    isGondola: boolean
    isFresh: boolean
    idLocationHeightType: number | null
    locationAttribute: LocationAttribute[]
}

export interface SelectOption {
    id: number
    description: string
}

export interface GetLocationsPayload {
    fulfillmentCenterId: number
    sheds: string[]
    streets: string[]
    shelves: string[]
    bins: string[]
    heightTypes: number[]
    isGondola: boolean[]
    isFresh: boolean[]
}

export interface FormAddLocationData {
    fulfillmentCenterId: number
    addressType: number
    addressHeight: number
    csvFile: File
}

export interface CreateLocationsByCsvPayload {
    id_fulfillment_center: number
    id_location_type: number
    id_location_height_type: number
    planilha: File
}

export interface CsvValidationError {
    erro: string
    linha: number
}

export interface CsvValidationErrorResponse {
    errors: CsvValidationError[]
    message: string
    status: string
}

export interface SetCsvValidationErrors {
    csvValidationErrors: ShedManagementState['csvValidationErrors']
}

export type FiltersSearchLocations = Omit<GetLocationsPayload, 'fulfillmentCenterId' | 'sheds'>

export enum FiltersSearchLocationsEnum {
    Streets = 'streets',
    Shelves = 'shelves',
    Bins = 'bins',
}

export interface GetShedsSearchLocationsPayload {
    fulfillmentCenterId: number,
}

export interface GetFiltersSearchLocationsPayload {
    fulfillmentCenterId: number,
    sheds: string[]
}

export interface SetShedsSearchLocations {
    shedsSearchLocations: ShedManagementState['shedsSearchLocations']
}

export interface SetFilterSearchLocations {
    filterSearchLocations: ShedManagementState['filtersSearchLocations']
}

export interface SetLocations {
    locations: ShedManagementState['locations']
}

export interface SetSelectedLocations {
    selectedLocations: ShedManagementState['selectedLocations']
}

export enum GenericApiErrors {
    Failed,
}

export interface LocationAttribute {
    id?: number,
    idAttribute: number
}
export interface Locations {
    id: number
    fulfillmentCenterId: number
    shed: string
    street: string
    shelf: string
    bin: string
    isGondola: boolean
    isFresh: boolean
    idLocationType: number
    idLocationHeightType: number
    locationAttribute: LocationAttribute[]
}

export interface LocationAttributeDiscrepancyErrors {
    heightType: string
    locationAddress: string
    missingTypes: string
}

export interface SetLocationAttributeDiscrepancyErrors {
    locationAttributeDiscrepancyErrors: ShedManagementState['locationAttributeDiscrepancyErrors']
}

export interface LocationHeightTypes {
    id: number
    name: string
}

export interface GetProductsPayload {
    productsCodes?: string[]
    productDescription?: string
}

export interface Product {
    idModel: number;
    productCode: string;
    productDescription: string;
    idAttributeType: number | null;
    idAttributeFunction: number | null;
    idAttributeStorage: number | null;
    allowHighStorage: boolean;
    fractioningTag: boolean;
    dueDateType: string;
}

export interface SetSelectedProducts {
    selectedProducts: ShedManagementState['selectedProducts']
}

export interface ProductAttributeDiscrepancyErrors {
    productCode: string
    missingTypes: string
}

export interface SetProductAttributeDiscrepancyErrors {
    productAttributeDiscrepancyErrors: ShedManagementState['productAttributeDiscrepancyErrors']
}

export const isYesNoOptionsList = [
  {
    id: 1,
    description: 'Sim',
  },
  {
    id: 0,
    description: 'Não',
  },
]
